<template>
  <NotificationsTwilioNewMessage
    v-if="
      notification.notification.notificationType ===
      TwilioNotificationType.NewMessage
    "
    :notification="notification.notification"
    :is-unread
  />
</template>

<script setup lang="ts">
import {
  TwilioNotificationType,
  type TwilioNotification,
} from "~/src/notifications/types/twilio";
import type { Props } from "../NotificationsItem.vue";

defineProps<
  {
    notification: TwilioNotification;
  } & Pick<Props, "isUnread">
>();
</script>
